<template>
  <div class="Others26Charts">
    <div class="stats-item">
      <div
        class="icon-box"
        :style="{
          width: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(84 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="../../../assets/img/Others26Charts/user-icon.png" alt="" />
      </div>
      <div class="text-content">
        <div
          class="title"
          :style="{
            fontSize: `${fontStyle.xAxisSize}px`,
            color: `${fontStyle.xAxisColor}`,
          }"
        >
          {{ data1.name }}
        </div>
        <div
          class="number"
          :style="{
            color: `${chartColor[0]}`,
          }"
        >
          <span
            :style="{
              fontSize: `${fontStyle.yAxisSize}px`,
            }"
            >{{ data1.value }}</span
          >
          <span
            :style="{
              fontSize: `${fontStyle.yAxisSize - 4}px`,
            }"
          >
            {{ iconUnit1 }}
          </span>
        </div>
      </div>
    </div>
    <div class="stats-item">
      <div
        class="icon-box"
        :style="{
          width: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(84 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="../../../assets/img/Others26Charts/money-icon.png" alt="" />
      </div>
      <div class="text-content">
        <div
          class="title"
          :style="{
            fontSize: `${fontStyle.xAxisSize}px`,
            color: `${fontStyle.xAxisColor}`,
          }"
        >
          {{ data2.name }}
        </div>
        <div
          class="number"
          :style="{
            color: `${chartColor[1]}`,
          }"
        >
          <span
            :style="{
              fontSize: `${fontStyle.yAxisSize}px`,
            }"
            >{{ data2.value }}</span
          >
          <span
            :style="{
              fontSize: `${fontStyle.yAxisSize - 4}px`,
            }"
          >
            {{ iconUnit2 }}
          </span>
        </div>
      </div>
    </div>
    <div class="stats-item">
      <div
        class="icon-box"
        :style="{
          width: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(84 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="../../../assets/img/Others26Charts/consume-icon.png" alt="" />
      </div>
      <div class="text-content">
        <div
          class="title"
          :style="{
            fontSize: `${fontStyle.xAxisSize}px`,
            color: `${fontStyle.xAxisColor}`,
          }"
        >
          {{ data3.name }}
        </div>
        <div
          class="number"
          :style="{
            color: `${chartColor[2]}`,
          }"
        >
          <span
            :style="{
              fontSize: `${fontStyle.yAxisSize}px`,
            }"
            >{{ data3.value }}</span
          >
          <span
            :style="{
              fontSize: `${fontStyle.yAxisSize - 4}px`,
            }"
          >
            {{ iconUnit3 }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CountTo } from 'vue3-count-to';
import { request } from '../../../common/request';

export default {
  name: 'Others26Charts',
  components: { CountTo },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      numberintervalTask1: null,
      numberintervalTask2: null,
      numberintervalTask3: null,
      fontStyle: {},
      chartColor: [],
      iconUnit1: '万人',
      iconUnit2: '万元',
      iconUnit3: '万元',
      val1: 0,
      val2: 0,
      val3: 0,
      data1: {
        name: '全域累计接待游客',
        value: 0,
        unit: '元',
        decimals: 0,
      },
      data2: {
        name: '全域旅游累计消费',
        value: 0,
        unit: '元',
        decimals: 0,
      },
      data3: {
        name: '今年累计消费',
        value: 0,
        unit: '元',
        decimals: 0,
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);

    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // this.setNumberinterval();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);

    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    setNumberinterval() {
      this.numberintervalTask1 = setInterval(() => {
        this.val1 = 0;

        setTimeout(() => {
          this.val1 = this.data1.value;
        }, 0);
      }, 5000);
      this.numberintervalTask2 = setInterval(() => {
        this.val2 = 0;

        setTimeout(() => {
          this.val2 = this.data2.value;
        }, 0);
      }, 7000);
      this.numberintervalTask3 = setInterval(() => {
        this.val3 = 0;

        setTimeout(() => {
          this.val3 = this.data3.value;
        }, 0);
      }, 9000);
    },

    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        case 'V12Style':
          style = {};
          if (bool) style['V12StyleTitle'] = true;
          style['V12Style'] = true;
          break;
        case 'V13Style':
          style = {};
          if (bool) style['V13StyleTitle'] = true;
          style['V13Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
        this.chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
        this.fontStyle = fontStyle;
      }
      if (this.Configuration.propertyData?.iconUnit1?.value) {
        this.iconUnit1 = this.Configuration.propertyData.iconUnit1.value;
      }
      if (this.Configuration.propertyData?.iconUnit2?.value) {
        this.iconUnit2 = this.Configuration.propertyData.iconUnit2.value;
      }
      if (this.Configuration.propertyData?.iconUnit3?.value) {
        this.iconUnit3 = this.Configuration.propertyData.iconUnit3.value;
      }

      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let xData = [];
      let yData = [];
      let xyData = [];
      let unit = '';

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unit = item.s;
              if (index >= 4) return;
              xData.push(item.x);
              yData.push(item.y);
              // decimals 数值 小数点留位
              xyData.push({
                name: item.x,
                value: Number(item.y),
                decimals: item.d,
              });
            }
          });
        });
      }
      DealData();

      // console.log(xyData, 'xyData xyData');
      this.data1.unit = unit;
      this.data2.unit = unit;
      this.data3.unit = unit;

      if (xyData[0]) {
        this.data1.name = xyData[0].name;
        this.data1.value = xyData[0].value;
        this.data1.decimals = xyData[0].decimals;
      }
      if (xyData[1]) {
        this.data2.name = xyData[1].name;
        this.data2.value = xyData[1].value;
        this.data2.decimals = xyData[0].decimals;
      }
      if (xyData[2]) {
        this.data3.name = xyData[2].name;
        this.data3.value = xyData[2].value;
        this.data3.decimals = xyData[0].decimals;
      }

      console.log(unit);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);
          data.source.forEach(item => {
            item.y = 0;
          });
          this.setEchartsOptions(data);
          setTimeout(() => {
            this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData));
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        // this.axios({
        //   method: 'get',
        //   url: ChartsData.apiData.apiUrl,
        // })
        let param = {
          method: 'get',
          url: ChartsData.apiData.apiUrl,
        };

        request(param)
          .then(res => {
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '图标文字',
    componentName: 'Others26Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others26Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['元'],
            source: [
              {
                s: '元',
                y: '122',
                x: '全域累计接待游客',
              },
              {
                s: '元',
                y: '67',
                x: '全域旅游累计消费',
              },
              {
                s: '元',
                y: '55',
                x: '今年累计消费',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      iconUnit1: {
        propertyComponentName: 'MapChartUnit',
        value: '万人',
      },
      iconUnit2: {
        propertyComponentName: 'MapChartUnit',
        value: '万元',
      },
      iconUnit3: {
        propertyComponentName: 'MapChartUnit',
        value: '万元',
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#fff',
          xAxisSize: 12,
          xAxisColor: '',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others26Charts {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  .stats-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    width: 30%;
  }

  .icon-box {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .icon-box img {
    width: 100%;
    height: 100%;
  }

  .user-icon {
    background-image: url('../../../assets/img/Others26Charts/user-icon.png'); /* 替换为实际图标路径 */
  }

  .money-icon {
    background-image: url('../../../assets/img/Others26Charts/money-icon.png'); /* 替换为实际图标路径 */
  }

  .consume-icon {
    background-image: url('../../../assets/img/Others26Charts/consume-icon.png'); /* 替换为实际图标路径 */
  }

  .text-content {
    display: flex;
    flex-direction: column;
    background: url('../../../assets/img/Others26Charts/textbg.png'); /* 替换为实际图标路径 */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .title {
    color: #b3d9ff;
    font-size: 16px;
    margin-bottom: 8px;
  }

  .number {
    font-size: 24px;
    font-weight: bold;
  }

  /* .blue-number {
    color: #56d9ff;
  }

  .green-number {
    color: #56ff7f;
  }

  .yellow-number {
    color: #ffd956;
  } */
}
</style>
